import { render, staticRenderFns } from "./ArriveDialog.vue?vue&type=template&id=2cb41922&scoped=true"
import script from "./ArriveDialog.vue?vue&type=script&lang=js"
export * from "./ArriveDialog.vue?vue&type=script&lang=js"
import style0 from "./ArriveDialog.vue?vue&type=style&index=0&id=2cb41922&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb41922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb41922')) {
      api.createRecord('2cb41922', component.options)
    } else {
      api.reload('2cb41922', component.options)
    }
    module.hot.accept("./ArriveDialog.vue?vue&type=template&id=2cb41922&scoped=true", function () {
      api.rerender('2cb41922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/components/ArriveDialog.vue"
export default component.exports